import { Select as AntSelect, SelectProps } from 'antd';
import { BaseSelectRef } from 'rc-select';
import styled from 'styled-components';

import { ChevronIcon } from '@assets/icons';

export type AntSelectProps = SelectProps & {
  children?: React.ReactNode;
  ref?: React.Ref<BaseSelectRef>;
};
const BaseSelect = ({
  className,
  placeholder = 'Select One',
  suffixIcon = <ChevronIcon direction='down' />,
  ...props
}: AntSelectProps) => {
  return (
    <AntSelect
      placeholder={placeholder}
      popupClassName={className}
      className={className}
      suffixIcon={suffixIcon}
      {...props}
    />
  );
};

export const Select = styled(BaseSelect)`
  &.ant-select {
    &:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover {
      .ant-select-selector {
        border-color: ${({ theme }) => theme.palette.primary[0]};
      }
    }
    .ant-select-selector {
      border-color: ${({ theme }) => theme.palette.stroke[0]};

      .ant-select-selection-placeholder {
        font-size: 12px;
      }
      .ant-select-selection-item {
        font-size: 12px;
      }
      .ant-select-selection-search {
        font-size: 12px;
      }
    }

    .ant-select-arrow {
      svg {
        width: 12px;
        path {
          stroke: ${({ theme }) => theme.palette.text[0]};
        }
      }
    }
  }
  &.ant-select-dropdown {
    border-radius: 4px;
    .ant-select-item {
      font-size: 12px;
      line-height: 16px;
      align-items: center;
    }
  }
`;
